<template>
  <div style='width:285px'>
    <!-- <el-button
      class="taskButtons"
      type="primary"
      size="small"
      @click="showDialog('addRound')"
      >新增轮次</el-button
    > -->
    <el-button
      class="taskButtons"
      type="primary"
      size="small"
      @click="showDialog('createProject')"
      >添加任务</el-button
    >
    <el-button
      class="taskButtons"
      type="primary"
      size="small"
      @click="showDialog('surveyors')"
      >设置调查员</el-button
    >
    <el-button
      class="taskButtons"
      type="primary"
      size="small"
      @click="showDialog('formList')"
      >设置测评表</el-button
    >
    <el-dialog
      :title="roundTitle"
      :visible.sync="projectVisible"
      class="projectDialog"
      width="98%"
      :before-close="cancel"
    >
      <el-form
        :model="form"
        v-if="projectVisible"
        ref="dynamicValidateForm"
        label-width="120"
        class="demo-dynamic"
      >
        <el-form-item
          label=""
          :rules="[
            { required: false, message: '请选择测评对象', trigger: 'blur' },
          ]"
        >
          <div class="taskObjectTable">
            <SubjectTree
              class="subjectTree"
              @clickTree="checkTree"
              :selects="true"
            />
            <SubjectMain
              ref="tabsView"
              class="subjectList"
              :clickGroupData="clickGroupData"
              :selects="true"
              :roundId="currentRound.id"
            />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="updateTaskEvent">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="30%"
      :before-close="cancel"
    >
      <el-form
        :model="form"
        v-if="visible"
        ref="dynamicValidateForm"
        label-width="120px"
      >
        <el-form-item
          v-if="type == 'edit'"
          label="测评对象名称"
          prop="taskEventName"
          :rules="{
            required: true,
            message: '请输入测评对象名称',
            trigger: 'blur',
          }"
        >
          <el-input v-model="form.taskEventName"></el-input>
        </el-form-item>
        <el-form-item
          v-if="type == 'edit'"
          label="测评对象描述"
          prop="taskEventComment"
          :rules="{
            required: false,
            message: '',
            trigger: 'blur',
          }"
        >
          <el-input v-model="form.taskEventComment"></el-input>
        </el-form-item>
        <el-form-item
          v-else-if="type == 'addRound'"
          label="轮次的名称"
          prop="name"
          :rules="{
            required: true,
            message: '请输入轮次名称',
            trigger: 'blur',
          }"
        >
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          v-else-if="type == 'surveyors'"
          prop="surveyor_id"
          label="调查员"
          :rules="[
            { required: true, message: '请选择调查员', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="form.surveyor_id"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in surveyorsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-else
          label="测评任务表"
          prop="evaluation_form_id"
          :rules="[
            { required: true, message: '请选择测评任务表', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="form.evaluation_form_id"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in formList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="updateTaskEvent">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSurveyors,
  upDateTaskEvents,
  createProject,
  addRounds,
  editTaskInfo,
  taskRounds,
} from "@/api/project";
import { getEvaluationFormList } from "@/api/evaluation-form";
import SubjectMain from "../subject/subject-list-main";
import SubjectTree from "../groups-tree";
export default {
  props: {
    // 选中的 Task 列表
    selectedTasks: {
      type: Array,
      default: () => [],
    },

    // 当前选中的 Round
    currentRound: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      visible: false,
      projectVisible: false,
      surveyorsList: [],
      formList: [],
      roundList: [],
      taskSelectObjectData: [],
      title: "",
      form: {
        surveyor_id: "",
        name: "",
        evaluation_form_id: "",
        taskEventComment: "",
        taskEventName: "",
        round_id: "",
      },
      type: "",
      roundTitle: "",
      clickGroupData: [],
    };
  },
  components: {
    SubjectMain,
    SubjectTree,
  },

  mounted() {
    this.getRounds();
  },
  methods: {
    checkTree(data) {
      this.clickGroupData = data;
      this.$refs.tabsView.setCheckList();
    },
    handleSelectionChange(data) {
      this.taskSelectObjectData = data;
    },
    getRounds() {
      let project_id = this.$route.params.id;
      taskRounds({ project_id }).then((res) => {
        this.roundList = res.data;
      });
    },

    getSurveyors() {
      this.title = "设置调查员";
      getSurveyors().then((res) => {
        this.surveyorsList = res.data;
        this.visible = true;
      });
    },

    getFormList() {
      let project_id = this.$route.params.id;
      let that = this;
      this.title = "设置测评规则";
      getEvaluationFormList({ project_id }).then((res) => {
        that.formList = res.data;
        that.visible = true;
      });
    },
    cancel() {
      this.visible = false;
      this.projectVisible = false;
      this.title = "";
      this.type = "";
      this.roundTitle = "";
      this.form = {
        surveyor_id: undefined,
        name: undefined,
        evaluation_form_id: undefined,
        taskEventComment: undefined,
        taskEventName: undefined,
        round_id: undefined,
      };
      if (this.$refs.tabsView) {
        this.$refs.tabsView.clearSelect();
      }
      if (this.$refs.dynamicValidateForm)
        this.$refs.dynamicValidateForm.resetFields();
      this.$emit("closeDialog");
    },
    updateTaskEvent() {
      let that = this;
      this.$forceUpdate();
      let surveyor_id = this.form.surveyor_id;
      let evaluation_form_id = this.form.evaluation_form_id;
      let task_ids = this.selectedTasks.map((item) => item.id);
      let project_id = this.$route.params.id;
      let subject_ids = new Array();
      if (this.$refs.tabsView) {
        subject_ids = this.$refs.tabsView.taskSelectObjectData.map(
          (item) => item.id
        );
      }

      this.$refs["dynamicValidateForm"].validate((valid) => {
        if (valid) {
          if (that.type == "createProject") {
            if (!subject_ids.length) {
              that.$message({
                type: "error",
                message: "请先选择任务",
              });
              return;
            }
            createProject({
              subject_ids,
              round_id: that.currentRound.id,
            }).then((res) => {
              this.$emit("success", that.type);
              that.cancel();
              this.$message({
                type: "success",
                message: "创建成功",
              });
            });
          } else if (that.type == "edit") {
            let { taskEventComment: comment, taskEventName: name } = that.form;
            editTaskInfo({ comment, name }, task_ids).then((res) => {
              that.$emit("success", that.type);
              that.cancel();
              that.$message({
                type: "success",
                message: "修改成功",
              });
            });
          } else if (that.type != "addRound") {
            upDateTaskEvents({
              task_ids,
              surveyor_id,
              evaluation_form_id,
            }).then((res) => {
              that.$emit("success", that.type);
              that.cancel();
              that.$message({
                type: "success",
                message: "更新成功",
              });
            });
          } else {
            addRounds({ project_id, name: that.form.name }).then((res) => {
              that.$emit("success", that.type);
              that.cancel();
              that.$message({
                type: "success",
                message: "创建成功",
              });
            });
          }
        } else {
          return false;
        }
      });
    },

    createProject() {
      if (!this.currentRound) {
        this.$message({
          type: "error",
          message: "请先添加轮次",
        });
        return;
      }
      this.roundTitle = this.currentRound.name + "-创建任务";
      this.projectVisible = true;
    },

    addRounds() {
      this.visible = true;
    },

    editTaskEvent() {
      this.visible = true;
      let data = this.selectedTasks[0];
      this.form.taskEventName = data.name;
      this.form.taskEventComment = data.comment;
    },

    showDialog(type) {
      let queryData = {
        surveyors: this.getSurveyors,
        formList: this.getFormList,
        createProject: this.createProject,
        addRound: this.addRounds,
        edit: this.editTaskEvent,
        taskActions: this.taskActions,
      };
      if (
        type !== "addRound" &&
        type !== "createProject" &&
        !this.selectedTasks.length
      ) {
        this.$message({
          type: "error",
          message: "请先选择需要更新的任务",
        });
        return;
      }
      queryData[type]();
      this.type = type;
    },
  },
};
</script>

<style lang="less" scoped>
.taskObjectTable {
  height: 760px;
  display: flex;
}

.subjectTree {
  width: 240px;
}

.subjectList {
  width: 100%;
}

.demo-dynamic .el-form-item {
  margin-bottom: 0 !important;
}

.projectDialog .el-dialog {
  margin-top: 1vh !important;
  margin-bottom: 0px !important;
}

.taskButtons + .taskButtons {
  margin-left: 0;
}
.taskButtons {
  margin-right: 10px;
  &:last-of-type {
    margin-right: 0px !important;
  }
}
</style>